export const setQueryTime = (time) => (dispatch)=>{
    dispatch({
        type: 'SET_QUERY_TIME',
        time
    })
}
